export { env } from '@shared/config/env'
